export default function Marquee({ items = [], className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div className={`overflow-hidden py-8 border-y border-line bg-surface/40 ${className}`} data-testid="services-marquee">
      <div className="marquee-track">
        {doubled.map((it, i) => (
          <span key={i} className="flex items-center gap-8 px-8 text-parchment/90">
            <span className="font-serif italic text-3xl md:text-5xl tracking-tight">{it}</span>
            <span className="text-copper text-4xl leading-none">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
